import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAppliedFiltersPayload } from '../../constants/utils';
import { useNavigate } from "react-router-dom";
import Header from '../Header'
import { Box, CircularProgress } from '@mui/material'
import { ROUTES } from '../../constants/routes';
import { COMPONENT_QUERY, REFRESH_TOKEN } from '../../constants/api';
import api from '../../services/api';
import { setUserAccessToken, setChannelsList, setChannelsListForActualSpend } from '../../modules/reducer/authSlice';
import { logout } from '../../modules/reducer/authSlice'
import { calendarActions } from '../../modules/reducer/calendarSlice';
import selectors from '../../modules/selectors/datePickerSelectors';
import { CALENDAR_DATE_DETAILS, CALENDAR_DETAIL, CHANNEL_DETAIL, CHANNEL_DETAIL_ACTUAL_SPEND } from './constant';
import { getUserDetails } from '../../modules/actions/authActions';

const Layout = ({ children }) => {
  const refreshTokenCalled = useRef(true);
  const { userRefreshToken, userAccessToken, loading, userData } = useSelector((state) => state.auth)
  const { calendarData } = useSelector(selectors.datePickerCombinedData)
  const tableId = userData?.data?.data_sources?.find(data => data?.name === "vw_spend_current_plan")?.identifier
  const tableIdForActual = userData?.data?.data_sources?.find(data => data?.name === "weekly_actual_spend")?.identifier
  const calenderId = userData?.data?.data_sources?.find(data => data?.name === "store_calendar")?.identifier;
  const [isLoading, setIsloading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const fallBackCurrentYear = new Date().getFullYear();

  async function refreshToken(data) {
    try {
      const response = await api.post(REFRESH_TOKEN, data);
      dispatch(setUserAccessToken(response.access));
    } catch (error) {
      if ((error?.response?.status) === 401) {
        dispatch(logout());
        navigate(ROUTES.login);
      }
      console.log("refreshToken API Error--->", error);
    }
  }

// For all the query API in the filters the YEAR value is hardcoded from before need to make it dynamic
// else it will break dashboard once the PELLA year changes
  async function fetchCalendarData() {
    try {
      const response = await api.post(COMPONENT_QUERY + `?component=${CALENDAR_DETAIL}`, getAppliedFiltersPayload(CALENDAR_DETAIL, [
        { "col": "date", "op": "TEMPORAL_RANGE", "val": "No filter" },
        { "col": "fiscal_year", "op": ">=", "val": "2019" },
        { "col": "fiscal_year", "op": "<=", "val": userData?.data?.current_year  || fallBackCurrentYear  }]
      ));

      dispatch(calendarActions.getCalendar(response?.data?.data?.calendar_detail?.result));
    } catch (error) {
      if ((error?.response?.status) === 401) {
        dispatch(logout());
        navigate(ROUTES.login);
      }
      console.log("fetchCalendarData API Error--->", error);
    }
  }

  async function fetchCalendarDataWithDate() {
    try {
      const response = await api.post(COMPONENT_QUERY + `?component=${CALENDAR_DATE_DETAILS}`, getAppliedFiltersPayload(CALENDAR_DATE_DETAILS, [
        { "col": "date", "op": "TEMPORAL_RANGE", "val": "No filter" },
        { "col": "fiscal_year", "op": "==", "val": userData?.data?.current_year || fallBackCurrentYear }]
      ));

      dispatch(calendarActions.getCalendarWithDate(response?.data?.data?.calendar_date_details?.result));
    } catch (error) {
      console.log("fetchCalendarDataWithDate API Error--->", error);
    }
  }

  async function fetchChannels() {
    try {
      const response = await api.post(COMPONENT_QUERY + `?component=${CHANNEL_DETAIL}`, getAppliedFiltersPayload(CHANNEL_DETAIL, [
        { col: 'fiscal_year', op: '==', val: userData?.data?.current_year || fallBackCurrentYear }]
      ));

      transformChannels(response?.data?.data);
      return response?.data
    } catch (error) {
      console.log("fetchChannels API Error--->", error);
    }
  }

  async function fetchChannelsForActualSpend() {
    try {
      const response = await api.post(COMPONENT_QUERY + `?component=${CHANNEL_DETAIL_ACTUAL_SPEND}`, getAppliedFiltersPayload(CHANNEL_DETAIL_ACTUAL_SPEND, [
        { col: 'fiscal_year', op: '==', val: userData?.data?.current_year || fallBackCurrentYear }]
      ));

      transformChannelForActualSpend(response?.data?.data);
      return response?.data
    } catch (error) {
      console.log("fetchChannelsForActualSpend API Error--->", error);
    }
  }

  const transformChannelForActualSpend = (channelsData) => {
    const channelsList = channelsData?.channel_detail_actual_spend?.result;
    if (channelsList && Array.isArray(channelsList)) {
      const options = channelsList.map(eachChannel => ({ label: eachChannel.channel, value: eachChannel.channel }));
      dispatch(setChannelsListForActualSpend(options));
    }
  }

  const transformChannels = (channelsData) => {
    const channelsList = channelsData?.channel_detail?.result;
    if (channelsList && Array.isArray(channelsList)) {
      const options = channelsList.map(eachChannel => ({ label: eachChannel.channel, value: eachChannel.channel }));
      dispatch(setChannelsList(options));
      dispatch(setChannelsListForActualSpend(options));
    }
  }

  useEffect(() => {
    setIsloading(true);
    if (refreshTokenCalled.current) {
      refreshTokenCalled.current = false;
      !userAccessToken && refreshToken({ refresh: userRefreshToken })
    }
    // making an API call to get the user details on refresh of the page if there is no current_year in the data
    if(!isLoading){
      dispatch(getUserDetails());
      setIsloading(false);
    }
  }, []);

  useEffect(() => {
    if (tableId && calenderId && !isLoading) {
      fetchCalendarData()
      fetchChannels()
      fetchChannelsForActualSpend()
      fetchCalendarDataWithDate()
    }
  }, [calenderId])

  useEffect(() => {
    if (calendarData && calendarData.length > 0) {
      dispatch(calendarActions.transformData(calendarData))
      dispatch(calendarActions.transformDataWithDate(calendarData))
    }
  }, [calendarData, dispatch])


  return (
    <>
      {loading ? <div style={{ display: "flex", justifyContent: "center", marginTop: "100px" }}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      </div> : <Header component={children} />}
    </>
  )
}

export default Layout
